import { render, staticRenderFns } from "./StockManage.vue?vue&type=template&id=a862e68a&scoped=true&"
import script from "./StockManage.vue?vue&type=script&lang=js&"
export * from "./StockManage.vue?vue&type=script&lang=js&"
import style0 from "./StockManage.vue?vue&type=style&index=0&id=a862e68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a862e68a",
  null
  
)

export default component.exports